<div class="main-container">
	@if (character$ | async; as character) {
		<!-- En-tête du personnage -->
		<div class="character-top-layout">

			<!-- IMAGE -->
			<div class="character-left">
				<img
					[src]="character?.imageUrl"
					alt="{{ character?.name }}"
					class="character-image"
				/>
			</div>

			<!-- DROITE -->
			<div class="character-right">

				<app-character-header
					[character]="character"
					[currentUser]="currentUser$ | async"
					[sessionActive]="sessionActive"
					(edit)="goToEdit(character._id)"
					(toggleVisibility)="onToggleVisibility()"
					(startSession)="startSession()"
					(endSession)="endSession()"
				/>

				@if (sessionActive) {
					<app-character-session-resources
						[character]="character"
						(modifyHp)="modifyHp($event)"
						(modifyMana)="modifyMana($event)"
					/>
				}

				<app-character-overview
					[character]="character"
					[lineage]="lineageDisplay$ | async"
				/>

			</div>

		</div>
		<!-- Onglets -->
		<ul class="nav nav-tabs custom-tabs" id="characterTabs" role="tablist">
			<li class="nav-item" role="presentation">
				<button
					class="nav-link active"
					id="stats-tab"
					data-bs-toggle="tab"
					data-bs-target="#stats"
					type="button"
					role="tab"
					aria-controls="stats"
					aria-selected="true"
				>
					<i class="bi bi-bar-chart-fill"></i> Statistiques
				</button>
			</li>
			<li class="nav-item" role="presentation">
				<button
					class="nav-link"
					id="traits-tab"
					data-bs-toggle="tab"
					data-bs-target="#traits"
					type="button"
					role="tab"
					aria-controls="traits"
					aria-selected="false"
				>
					<i class="bi bi-bookmark-heart"></i> Traits
				</button>
			</li>
			<li class="nav-item" role="presentation">
				<button
					class="nav-link"
					id="masteries-tab"
					data-bs-toggle="tab"
					data-bs-target="#masteries"
					type="button"
					role="tab"
					aria-controls="masteries"
					aria-selected="false"
				>
					<i class="bi bi-award"></i> Maîtrises & Langues
				</button>
			</li>
			<li class="nav-item" role="presentation">
				<button
					class="nav-link"
					id="skills-tab"
					data-bs-toggle="tab"
					data-bs-target="#skills"
					type="button"
					role="tab"
					aria-controls="skills"
					aria-selected="false"
				>
					<i class="bi bi-lightning-charge"></i> Compétences
				</button>
			</li>
			<li class="nav-item" role="presentation">
				<button
					class="nav-link"
					id="equipment-tab"
					data-bs-toggle="tab"
					data-bs-target="#equipment"
					type="button"
					role="tab"
					aria-controls="equipment"
					aria-selected="false"
				>
					<i class="bi bi-backpack"></i> Équipement
				</button>
			</li>
			<li class="nav-item" role="presentation">
				<button
					class="nav-link"
					id="backstory-tab"
					data-bs-toggle="tab"
					data-bs-target="#backstory"
					type="button"
					role="tab"
					aria-controls="backstory"
					aria-selected="false"
				>
					<i class="bi bi-book"></i> Histoire
				</button>
			</li>
		</ul>

		<!-- Contenu des onglets -->
		<div class="tab-content" id="characterTabsContent">
			<!-- Onglet Statistiques -->
			<div class="tab-pane fade show active" id="stats" role="tabpanel" aria-labelledby="stats-tab">
				<app-character-stats
					[character]="character"
					[primaryStats]="primaryStats$ | async"
					[secondaryStats]="secondaryStats$ | async"
					[bonuses]="bonuses$ | async"
				/>
			</div>

			<!-- Onglet Traits -->
			<div class="tab-pane fade" id="traits" role="tabpanel" aria-labelledby="traits-tab">
				<div class="traits-container">
					<div class="trait-card positive-trait">
						<h4 class="trait-title"><i class="bi bi-plus-circle-fill text-success"></i> Trait Positif</h4>
						<div class="trait-content" [innerHTML]="formatText(character.positive_trait)"></div>
					</div>
					<div class="trait-card negative-trait">
						<h4 class="trait-title"><i class="bi bi-dash-circle-fill text-danger"></i> Trait Négatif</h4>
						<div class="trait-content" [innerHTML]="formatText(character.negative_trait)"></div>
					</div>
				</div>
			</div>

			<!-- Onglet Maîtrises et Langues -->
			<div class="tab-pane fade" id="masteries" role="tabpanel" aria-labelledby="masteries-tab">
				<div class="row">
					<div class="col-lg-7">
						<h4 class="section-title"><i class="bi bi-award-fill"></i> Maîtrises</h4>
						<div class="mastery-list">
							@for (mastery of character?.masteries; track mastery) {
								<span class="mastery-badge">
								<i class="bi bi-check-circle"></i> {{ mastery }}
							</span>
							}
						</div>
					</div>
					<div class="col-lg-5">
						<h4 class="section-title"><i class="bi bi-translate"></i> Langues</h4>
						<div class="language-list">
							@for (language of character?.languages; track language) {
								<span class="language-badge">
								<i class="bi bi-chat-square-text"></i> {{ language }}
							</span>
							}
						</div>
					</div>
				</div>
			</div>

			<!-- Onglet Compétences -->
			<div class="tab-pane fade" id="skills" role="tabpanel" aria-labelledby="skills-tab">
				<app-character-skills
					[character]="character"
				/>
			</div>


			<!-- Onglet Équipement -->
			<div class="tab-pane fade" id="equipment" role="tabpanel" aria-labelledby="equipment-tab">
				<div class="equipment-section">
					<div class="gold-display">
						<h4>
							<i class="bi bi-coin text-warning"></i>
							Richesse : <span class="gold-amount">{{ character?.gold }}</span> pièces d'or
						</h4>
					</div>
					<div class="inventory-section">
						<h4 class="section-title"><i class="bi bi-bag-fill"></i> Inventaire</h4>
						<div class="inventory-content" [innerHTML]="character?.inventory"></div>
					</div>
				</div>
			</div>

			<!-- Onglet Histoire -->
			<div class="tab-pane fade" id="backstory" role="tabpanel" aria-labelledby="backstory-tab">
				<div class="backstory-section">
					<h3 class="section-title"><i class="bi bi-book-half"></i> Histoire du Personnage</h3>
					<div class="backstory-content" [innerHTML]="formatText(character.backstory)"></div>
				</div>
			</div>
		</div>

		<!-- Bouton de retour -->
		@if (!sessionActive) {
			<div class="back-section">
				<a routerLink="/characters" class="btn btn-custom btn-back"> <i class="bi bi-arrow-left-circle"></i>
					Retour à la liste </a>
			</div>
		}
	}
</div>
